import { React, useState, useEffect, useRef } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
} from "../../styledElements";
import { Button, Row, Col, Form, Input, PageHeader, Radio, Tooltip } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import { useLocation, useNavigate } from "react-router";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";
import { Switch } from "antd";
import { GlobalSet, Styled } from "../../pageStyled";
import { currency_List } from "../../../Utils/Constant/MeasurementUnitList";
import { lengthUnit, weightUnit } from "../../../Utils/Constant/MeasurementUnitList";
import { toHandlePOName } from "../../../Utils/helper/helper";

const exportCustomerData = [
  { label: "CSV", value: "CSV" },
  // { label: "PDF", value: "PDF" },
];

const statusMap = {
  review: "Changes Requested",
  hold: "On Hold",
  in_production: "In Production",
  cancel: "Cancelled",
  open: "Provisional",
  pending: "Pending Confirmation",
  rejected: "Confirmation Rejected",
  approved: "Active",
  complete: "Produced",
};

const capitalize = (item) => item?.charAt(0).toUpperCase() + item?.slice(1);

const ExportOrders = (props) => {
  const location = useLocation();
  const [orderRecords, setOrderRecords] = useState([]);
  const [exportOrderDetail, setExportOrderDetail] = useState(
    exportCustomerData[0].value
  );
  const [orderMangtRecords, setOrderMangtRecords] = useState(location.state?.orderMangtRecords ? location.state?.orderMangtRecords : []);
  const [deckleOrders, setDeckleOrders] = useState(location.state?.deckleOrders ? location.state?.deckleOrders : []);
  const [onBack, setOnBack] = useState(location.state?.onBack ? location.state?.onBack : false);
  const [fileName, setFileName] = useState(location.state?.fileName);
  // const [switchReelCoreOD, setSwitchReelCoreOD] = useState(location?.state? location?.state?.switchReelCoreOD : false);
  const [switchOrderFormat, setSwitchOrderFormat] = useState(location?.state? location?.state?.switchOrderFormat : false);
  // const [switchPlannedWt, setSwitchPlannedWt] = useState(location?.state? location?.state?.switchPlannedWt : false);
  // const [switchPlannedReels, setSwitchPlannedReels] = useState(location?.state? location?.state?.switchPlannedReels : false);
  const [switchPrice, setSwitchPrice] = useState(location?.state? location?.state?.switchPrice : false);
  const [switchAddress, setSwitchAddress] = useState(location?.state? location?.state?.switchAddress : false);
  const [shippingAddress, setShippingAddress] = useState(location?.state? location?.state?.shippingAddress : false);
  const [billingAddress, setBillingAddress] = useState(location?.state? location?.state?.billingAddress : false);
  const [switchApprover, setSwitchApprover] = useState(location?.state? location?.state?.switchApprover : false);
  const [switchCreatedBy, setSwitchCreatedBy] = useState(location?.state? location?.state?.switchCreatedBy : false);
  const [switchDeliveryDate, setSwitchDelDate] = useState(location?.state? location?.state?.switchDeliveryDate : false);
  const [switchStatus, setSwitchStatus] = useState(location?.state? location?.state?.switchStatus : false);
  const [switchPriority, setSwitchPriority] = useState(location?.state? location?.state?.switchPriority : false);
  const [switchProductName, setSwitchProductName] = useState(location?.state? location?.state?.switchProductName : false);
  // const [switchDispatchedQty, setSwitchDispatchedQty] = useState(location?.state? location?.state?.switchDispatchedQty : false);
  const [switchDiameter, setSwitchDiameter] = useState(location?.state? location?.state?.switchDiameter : false);
  const [switchQtyPlanned, setSwitchQtyPlanned] = useState(location?.state? location?.state?.switchQtyPlanned : false);
  const [switchPackaging, setSwitchPackaging] = useState(location?.state? location?.state?.switchPackaging : false);
  const [switchCreatedDate, setSwitchCreatedDate] = useState(location?.state? location?.state?.switchCreatedDate : false);

  const navigate = useNavigate();

      let moistureArr = orderRecords?.filter(ele => ele.moisture);
      let BFArr = orderRecords?.filter(ele => ele.BF);
      let headersForOrderMangt = [];
      headersForOrderMangt.push(
        { label: "PO DATE", key: "poDate" },
        { label: "PO NO.", key: "poNo" },
        { label: "ORDER NO.", key: "orderNo" },
        // { label: "GROUP NO.", key: "groupNo" },
        { label: "CUSTOMER   NAME", key: "customerName" },
        { label: "CONSIGNEE", key: "consignee" });
       
        if(switchProductName){
          headersForOrderMangt.push(
           { label: "PRODUCT NAME", key: "productName" }
          );
        }

        headersForOrderMangt.push(
          { label: "PRODUCT CODE", key: "productCode"},
          { label: "GRADE", key: "grade" },
          { label: "QUALITY", key: "quality" },
          { label: "GSM", key: "GSM" },
          { label: "BF", key: "BF" },
          { label: "MOISTURE", key: "moisture" });

      headersForOrderMangt.push(
        { label: "ORDER TYPE", key: "type" },
        { label: "PLY", key: "ply" },
        { label: "GRAIN", key: "grain" },
        { label: "WIDTH", key: "width" },
        { label: "LENGTH", key: "length" }
      );
      if (switchOrderFormat) {
        headersForOrderMangt.push({
          label: "ORDERED FORMAT",
          key: "orderFormat",
        });
      }
      headersForOrderMangt.push(
        { label: "ORDERED QUANTITY", key: "orderQuantity" },
        { label: "PENDING QUANTITY", key: "pendingQuantity" },
        { label: "PROCESSED QUANTITY", key: "processedQuantity" },
        { label: "CANCELLED QUANTITY", key: "cancelledQuantity" },
      );
      if(switchPrice){
        headersForOrderMangt.push(
          { label: "DEALER'S PRICE", key: "dealerPrice" },
          { label: "CUSTOMER'S PRICE", key: "customerPrice" },
          { label: "NET PRICE", key: "netPrice" }
        );
      }
      if(switchPackaging){
        headersForOrderMangt.push(
          { label: "PACKAGING TYPE", key: "packagingType" }
          );
      }
      if (switchAddress) {
        headersForOrderMangt.push(
          { label: "DELIVERY ADDRESS-", key: "deliveryAddress" }
        );
      }
      if (shippingAddress) {
        headersForOrderMangt.push(
          { label: "SHIPPING ADDRESS-", key: "shippingAddress" }
        );
      }
      if (billingAddress) {
        headersForOrderMangt.push(
          { label: "BILLING ADDRESS-", key: "billingAddress" }
        );
      }
      if(switchDeliveryDate){
        headersForOrderMangt.push({ label: "DELIVERY DATE", key: "deliveryDate" });
      }
      if(switchCreatedDate){
        headersForOrderMangt.push({ label: "CREATED DATE", key: "createdDate" });
      }
      if(switchPriority){
        headersForOrderMangt.push({ label: "PRIORITY", key: "priorityValue" });
      }
      headersForOrderMangt.push(
        { label: "REMARKS", key: "remarks" }
      );
      if(switchStatus){
        headersForOrderMangt.push({ label: "STATUS", key: "status" });
      }
      if (switchApprover) {
        headersForOrderMangt.push({ label: "APPROVED BY", key: "approvedBy" });
      }
      if (switchCreatedBy) {
        headersForOrderMangt.push({ label: "CREATED BY", key: "createdBy" });
      }


      let headersForDeckleMangt = [];
      headersForDeckleMangt.push(
        { label: "PO DATE", key: "poDate" },
        { label: "PO NO.", key: "poNo" },
        { label: "ORDER NO.", key: "orderNo" },
        { label: "CUSTOMER   NAME", key: "customer" },
        { label: "CONSIGNEE", key: "consignee" }
      );
        
      if(switchProductName){
        headersForDeckleMangt.push(
          { label: "PRODUCT NAME", key: "productName" }
        );
      }
      headersForDeckleMangt.push(
      { label: "PRODUCT CODE", key: "productCode"},
      { label: "GRADE", key: "grade" },
      { label: "QUALITY", key: "quality" },
      { label: "GSM", key: "GSM" },
      { label: "BF", key: "BF" },
      { label: "MOISTURE", key: "moisture" },
      { label: "ORDER TYPE", key: "type" },
      { label: "PLY", key: "ply" },
      { label: "GRAIN", key: "grain" },
      { label: "LENGTH", key: "length" },
      { label: "WIDTH", key: "width" }
      );
      if (switchOrderFormat) {
        headersForDeckleMangt.push({
          label: "ORDERED FORMAT",
          key: "orderFormat",
        });
      }
      headersForDeckleMangt.push(
        { label: "ORDERED QUANTITY", key: "orderQuantity" },
        { label: "PENDING QUANTITY", key: "pendingQuantity" },
        { label: "PROCESSED QUANTITY", key: "processedQuantity" },
        { label: "CANCELLED QUANTITY", key: "cancelledQuantity" },
      );
      // if(switchDispatchedQty){
      //   headersForDeckleMangt.push(
      //   { label: "DISPATCHED QUANTITY", key: "dispatchedQty" }
      //   );
      // }
      if(switchQtyPlanned){
        headersForDeckleMangt.push(
          { label: "QUANTITY TO BE PLANNED", key: "plannedQty" }
          );
      }
      if(switchPackaging){
        headersForDeckleMangt.push(
          { label: "PACKAGING TYPE", key: "packagingType" }
          );
      }
      if (switchAddress) {
        headersForDeckleMangt.push(
          { label: "DELIVERY ADDRESS-", key: "deliveryAddress" }
        );
      }
      if (shippingAddress) {
        headersForDeckleMangt.push(
          { label: "SHIPPING ADDRESS-", key: "shippingAddress" }
        );
      }
      if (billingAddress) {
        headersForDeckleMangt.push(
          { label: "BILLING ADDRESS-", key: "billingAddress" }
        );
      }
      if(switchDeliveryDate){
        headersForDeckleMangt.push({ label: "DELIVERY DATE", key: "deliveryDate" });
      }
      if(switchPriority){
        headersForDeckleMangt.push({ label: "PRIORITY", key: "priorityValue" });
      }
      if(switchDiameter){
        headersForDeckleMangt.push(
          { label: "REEL OD", key: "reelOD" },
          { label: "CORE OD", key: "coreOD" }
        );
      }
      headersForDeckleMangt.push(
        { label: "REMARKS", key: "remarks" }
      );
      if (switchApprover) {
        headersForDeckleMangt.push({ label: "APPROVED BY", key: "approvedBy" });
      }
      if (switchCreatedBy) {
        headersForDeckleMangt.push({ label: "CREATED BY", key: "createdBy" });
      }

  useEffect(() => {
    if(!onBack){
      if(orderMangtRecords.length){
        fetchOrderRecords();
      } else {
        fetchDeckleRecords();
      }
   } else{
    if(orderMangtRecords.length){
      setOrderRecords(orderMangtRecords);
    } else{
      setOrderRecords(deckleOrders);
    }
  }
  }, [orderMangtRecords,deckleOrders]);

  useEffect(()=> {
    //only for PDF option
    //   else if (!onBack) {
    //     if(orderMangtRecords?.length){
    //     navigate(`${location?.state?.rootPage}/export-orders/pdf`, {
    //           state: {
    //             body: location?.state?.body,
    //               orderMangtRecords: orderRecords,
    //               // switchReelCoreOD: switchReelCoreOD,
    //               switchOrderFormat: switchOrderFormat,
    //               // switchPlannedWt: switchPlannedWt,
    //               // switchPlannedReels: switchPlannedReels,
    //               switchPrice: switchPrice,
    //               switchAddress: switchAddress,
    //               shippingAddress: shippingAddress,
    //               billingAddress: billingAddress,
    //               switchApprover: switchApprover,
    //               switchCreatedBy: switchCreatedBy,
    //               switchDeliveryDate: switchDeliveryDate,
    //               switchCreatedDate: switchCreatedDate,
    //               switchStatus: switchStatus,
    //               switchPriority: switchPriority,
    //               switchProductName: switchProductName,
    //               switchDiameter: switchDiameter,
    //               switchQtyPlanned: switchQtyPlanned,
    //               switchPackaging: switchPackaging,
    //               switchDiameter: switchDiameter,
    //               rootPage: location?.state?.rootPage,
    //               fileName: fileName,
    //               exportOrderDetail: exportOrderDetail,
    //             },
    //     });
    //   } else {
    //     navigate(`${location?.state?.rootPage}/export-orders/pdf`, {
    //       state: {
    //           body: location?.state?.body,
    //           deckleOrders: orderRecords,
    //           // switchReelCoreOD: switchReelCoreOD,
    //           switchOrderFormat: switchOrderFormat,
    //           // switchPlannedWt: switchPlannedWt,
    //           // switchPlannedReels: switchPlannedReels,
    //           switchPrice: switchPrice,
    //           switchAddress: switchAddress,
    //           shippingAddress: shippingAddress,
    //           billingAddress: billingAddress,
    //           switchApprover: switchApprover,
    //           switchCreatedBy: switchCreatedBy,
    //           switchDeliveryDate: switchDeliveryDate,
    //           switchCreatedDate: switchCreatedDate,
    //           switchStatus: switchStatus,
    //           switchPriority: switchPriority,
    //           switchProductName: switchProductName,
    //           switchQtyPlanned: switchQtyPlanned,
    //           switchPackaging: switchPackaging,
    //           switchDiameter: switchDiameter,
    //           rootPage: location?.state?.rootPage,
    //           fileName: fileName,
    //           count: location?.state?.count,
    //           exportOrderDetail: exportOrderDetail
    //         },
    //     });
    //   }
    // }
  // }
  },[orderRecords]);

  //Deckle records
  const fetchDeckleRecords = async () => {
    let exportDataJSON = {};
    const exporDataArr = [];
    let deckleOrder = deckleOrders?.sort((a, b) => (new Date(b.po_date) - new Date(a.po_date)));
    deckleOrder?.map((item) => {
      let plyName;
      if(item.ply == 1){
        plyName = "Single Ply";
      } else if(item.ply == 2){
        plyName = "Double Ply";
      } else if(item.ply == 2){
        plyName = "3-Ply";
      } else{
        plyName = "4-Ply";
      }
      let priceUnit = currency_List.filter(currUnit => currUnit.code === item.units.net_price);
      exportDataJSON = {};
      exportDataJSON["poNo"] = item.po? toHandlePOName(item.po) : "";
      exportDataJSON["poDate"] = item.po_date? moment(item.po_date).format("DD-MM-YYYY") : "";
      exportDataJSON["orderNo"] = item.number? item.number : "";
      exportDataJSON["produced"] = item.completed? item.completed : 0;
      exportDataJSON["createdDate"] = item.created_at? moment(item.created_at).format("DD-MM-YYYY") : "";
      exportDataJSON["productSpec"] = item.product_spec? item.product_spec : "";
      exportDataJSON["productCode"] = item.product? item.product : "";
      exportDataJSON["productName"] = item.product_info? item.product_info.name : "";
      exportDataJSON["grade"] = item.product_info? item.product_info.grade  : "";
      exportDataJSON["quality"] = item.product_info? item.product_info.quality : "";
      exportDataJSON["GSM"] = item.product_info? item.product_info.gsm : "";
      exportDataJSON["BF"] = item.product_info? item.product_info.burst_factor : "";
      exportDataJSON["moisture"] = item.product_info? item.product_info.moisture : 0;
      exportDataJSON["grain"] = item.grain? item.grain : "";
      exportDataJSON["length"] = `${item.length? item.length : 0}` + ` ${item.units.length ? `${lengthUnit[item.units.length]?.displayName?.toUpperCase()}` : ""}`;
      exportDataJSON["width"] = `${item.width? item.width : 0}` + ` ${item.units.width ? `${lengthUnit[item.units.width]?.displayName?.toUpperCase()}` : ""}`;
      // exportDataJSON["coreOD"] = `${item.core_id? item.core_id : 0}` + ` ${item.units.core_id ? `${lengthUnit[item.units.core_id]?.displayName?.toUpperCase()}` : ""}`;
      // exportDataJSON["reelOD"] = `${item.reel_od? item.reel_od : 0}` + ` ${item.units.reel_od ? `${lengthUnit[item.units.reel_od]?.displayName?.toUpperCase()}` : ""}`;
      exportDataJSON["coreOD"] = item.inner_dia;
      exportDataJSON["reelOD"] = item.id_od_type == "range" ? ((item.minimum_reel_od + "-" + item.maximum_reel_od) + " " + (lengthUnit[item.units.maximum_reel_od]?.displayName?.toUpperCase())) : item.outer_dia;
      exportDataJSON["customer"] = item.customer_name? item.customer_name : "";
      exportDataJSON["processedWeight"] = `${item.processed_weight? item.processed_weight.toFixed(3) : 0}` + ` ${item.units.planned_weight ? `${weightUnit[item.units.planned_weight]?.displayName?.toUpperCase()}` : ""}`;
      exportDataJSON["processedQuantity"] = item.processed_quantity? item.processed_quantity : 0;
      exportDataJSON["deliveryDate"] = item.delivery_date? moment(item.delivery_date).format("DD-MM-YYYY") : "";
      exportDataJSON["deliveryAddress1"] = item.delivery_address_line_1? item.delivery_address_line_1 : "";
      exportDataJSON["deliveryAddress2"] = item.delivery_address_line_2? item.delivery_address_line_2 : "";
      exportDataJSON["deliveryCity"] = item.delivery_city? item.delivery_city : "";
      exportDataJSON["deliveryCountry"] = item.delivery_country? item.delivery_country : "";
      exportDataJSON["deliveryPincode"] = item.delivery_pincode? item.delivery_pincode : "";
      exportDataJSON["deliveryState"] = item.delivery_state? item.delivery_state : "";
      exportDataJSON["deliveryAddress"] = ((item.delivery_address_line_1? item.delivery_address_line_1 : "") + (item.delivery_address_line_2? (", " + item.delivery_address_line_2) : "") + 
      (item.delivery_city? (", " + item.delivery_city) : "") + "" + (item.delivery_state? (", " + item.delivery_state) : "") + (item.delivery_country? (", " + item.delivery_country) : "") + "" + 
      (item.delivery_country? (", " + item.delivery_country) : "") + "" + (item.delivery_pincode? (", " + item.delivery_pincode) : ""));
      exportDataJSON["quotedPrice"] = `${priceUnit ?  priceUnit[0]?.symbol : ""}` + ` ${item.quoted_price? parseFloat(item.quoted_price).toFixed(3)+ " " + `${item?.units?.per_weight_unit ? (" /" + weightUnit[item.units.per_weight_unit]?.displayName?.toUpperCase()) : ""}` : ""}`;
      exportDataJSON["netPrice"] = `${priceUnit ?   priceUnit[0]?.symbol : ""}` + ` ${item.net_price? parseFloat(item.net_price).toFixed(3) : ""}`;
      exportDataJSON["plannedReels"] = item.quantity? item.quantity : 0;
      exportDataJSON["createdBy"] = item.created_by? item.created_by : "";
      exportDataJSON["approvedBy"] = item.approved_by? item.approved_by : "";
      exportDataJSON["groupNo"] = item.split_group? item.split_group : "";
      exportDataJSON["type"] = item.type? capitalize(item.type) : "";
      exportDataJSON["ply"] = item.ply ? plyName : "";
      exportDataJSON["consignee"] = item.consignee_name? item.consignee_name : "";
      exportDataJSON["shippingAddress"] = ((item.po_details?.shipping_address_line_1? item.po_details?.shipping_address_line_1 : "") +
      (item.po_details?.shipping_address_line_2? (", " + item.po_details?.shipping_address_line_2) : "") + (item.po_details?.shipping_city? (", " + item.po_details?.shipping_city) : "") +
      (item.po_details?.shipping_state? (", " + item.po_details?.shipping_state) : "") + (item.po_details?.shipping_country? (", " + item.po_details?.shipping_country) : "") + 
      (item.po_details?.shipping_pincode? (", " + item.po_details?.shipping_pincode) : ""));
      exportDataJSON["shippingAddress1"] = item.po_details?.shipping_address_line_1? item.po_details?.shipping_address_line_1 : "";
        exportDataJSON["shippingAddress2"] = item.po_details?.shipping_address_line_2? item.po_details?.shipping_address_line_2 : "";
        exportDataJSON["shippingCity"] = item.po_details?.shipping_city? item.po_details?.shipping_city : "";
        exportDataJSON["shippingCountry"] = item.po_details?.shipping_country? item.po_details?.shipping_country : "";
        exportDataJSON["shippingPincode"] = item.po_details?.shipping_pincode? item.po_details?.shipping_pincode : "";
        exportDataJSON["shippingState"] = item.po_details?.shipping_state? item.po_details?.shipping_state : "";
        exportDataJSON["billingAddress"] = ((item.po_details?.billing_address_line_1? item.po_details?.billing_address_line_1 : "") + (item.po_details?.billing_address_line_2? (", " + item.po_details?.billing_address_line_2) : "")
        + (item.po_details?.billing_city? (", " + item.po_details?.billing_city) : "") + (item.po_details?.billing_state? (", " + item.po_details?.billing_state) : "") + (item.po_details?.billing_country? (", " + item.po_details?.billing_country) : "")
        + (item.po_details?.billing_pincode? (", " + item.po_details?.billing_pincode) : ""));
        exportDataJSON["billingAddress1"] = item.po_details?.billing_address_line_1? item.po_details?.billing_address_line_1 : "";
        exportDataJSON["billingAddress2"] = item.po_details?.billing_address_line_2? item.po_details?.billing_address_line_2 : "";
        exportDataJSON["billingCity"] = item.po_details?.billing_city? item.po_details?.billing_city : "";
        exportDataJSON["billingCountry"] = item.po_details?.billing_country? item.po_details?.billing_country : "";
        exportDataJSON["billingPincode"] = item.po_details?.billing_pincode? item.po_details?.billing_pincode : "";
        exportDataJSON["billingState"] = item.po_details?.billing_state? item.po_details?.billing_state : "";
      if (item.hasOwnProperty('planned_weight') && item.planned_weight!= 0) {
        exportDataJSON["plannedWeight"] = item.planned_weight.toFixed(3) + ` ${item.units.planned_weight ? `${weightUnit[item.units.planned_weight]?.displayName?.toUpperCase()}` : ""}`;
      } else {
        exportDataJSON["plannedWeight"] = 0 + ` ${item.units.planned_weight ? `${weightUnit[item.units.planned_weight]?.displayName?.toUpperCase()}` : ""}`;
      }

      if (item.hasOwnProperty('quantity') && item.hasOwnProperty('completed') && item.hasOwnProperty('in_production') && item.hasOwnProperty('in_process')) {
        exportDataJSON["pendingReels"] = item.quantity - item.completed - item.in_production - item.in_process;
      } else {
        exportDataJSON["pendingReels"] = 0;
      }

      exportDataJSON["pendingWeight"] = `${item.pending_quantity_weight? item.pending_quantity_weight.toFixed(3) : 0} ${item.units.planned_weight ? `${weightUnit[item.units.planned_weight]?.displayName?.toUpperCase()}` : ""} ` ;
      exportDataJSON["pendingQuantity"] = item.pending_quantity? item.pending_quantity.toFixed(3) : 0 + `${item.units.planned_weight ? `${weightUnit[item.units.planned_weight]?.displayName?.toUpperCase()}` : ""}`;
      if (item.quantity_type) {
        if (item.quantity_type == "weight") {
          exportDataJSON["orderFormat"] = "Weight";
          exportDataJSON["orderWeight"] = `${item.weight? item.weight : 0} ${item.units.weight ? `${weightUnit[item.units.weight]?.displayName?.toUpperCase()}` : ""}` ;
        } else{
          exportDataJSON["orderQuantity"] = item.no_of_reel_sheet ? item.no_of_reel_sheet : 0 ;
          if(item.type == "reel"){
            exportDataJSON["orderFormat"] = "Reels";
          } else{
            exportDataJSON["orderFormat"] = "Sheets";
          }
        }
     } else{
      exportDataJSON["orderWeight"] = 0 + `${item.units.weight ? `${weightUnit[item.units.weight]?.displayName?.toUpperCase()}` : ""}`;
      exportDataJSON["orderQuantity"] = 0;
     }

    //  if (item.hasOwnProperty('comments')){
    //   exportDataJSON["remarks"] = item.comments? item.comments[item.comments.length-1] : "";
    //  } else{
    //   exportDataJSON["remarks"] = "";
    //  }
    exportDataJSON["remarks"] = item.remarks;
     if(item.hasOwnProperty("forced")){
      exportDataJSON["priority"] = item.forced;
      exportDataJSON["priorityValue"] = item.forced? "Yes" : "No"; 
     } else{
      exportDataJSON["priority"] = false;
     }
     exportDataJSON["packagingType"] = item.packaging_details? capitalize(item.packaging_details?.type) : "";
     exportDataJSON["plannedQty"] = item.quantity_type == "weight" ? (item.planning_weight+ " " + capitalize(weightUnit[item.units.weight]?.displayName)) : (item.planning_quantity + " " + capitalize(item.type)+"s"); 
     exportDataJSON["orderQuantity"] = item.quantity_type == "weight" ? (item.weight + " " + capitalize(weightUnit[item.units.weight]?.displayName)) : (item.no_of_reel_sheet + " " + capitalize(item.type)+"s");
     exportDataJSON["pendingQuantity"] = item.total_pending_quantity ? ((item.type.toLowerCase() == "reel" && item.quantity_type == "reel_sheet" ) ? (item.total_pending_quantity?.quantity + " Reels") : (item.total_pending_quantity?.weight + " " + (item.total_pending_quantity.units ? capitalize(weightUnit[item.total_pending_quantity.units.weight]?.displayName) : "")) ): "";
     exportDataJSON["processedQuantity"] = item.total_processed_quantity ? ((item.type.toLowerCase() == "reel" && item.quantity_type == "reel_sheet" ) ? (item.total_processed_quantity.quantity + " Reels") : (item.total_processed_quantity?.weight + " " + (item.total_processed_quantity.units ? capitalize(weightUnit[item.total_processed_quantity.units.weight]?.displayName) : ""))): "";
     exportDataJSON["cancelledQuantity"] = item.cancelled_quantity ? ((item.type.toLowerCase() == "reel" && item.quantity_type == "reel_sheet" ) ? (item.cancelled_quantity.quantity + " Reels") : (item.cancelled_quantity?.weight + " " + (item.cancelled_quantity.units ? capitalize(weightUnit[item.cancelled_quantity.units]?.displayName) : ""))): "";
     exporDataArr.push(exportDataJSON);
    });
    setOrderRecords(exporDataArr);
    location?.state?.exportOrderDetail && setExportOrderDetail(location?.state?.exportOrderDetail);
  }
  
  //order management records
  const fetchOrderRecords = async () => {
    let exportDataJSON = {};
    let exporDataArr = [];
    let orderMangtRecord = orderMangtRecords?.sort((a, b) => (new Date(b.po_date) - new Date(a.po_date)));
    
    orderMangtRecord?.map((item) => {
      let plyName;
      if(item.ply == 1){
        plyName = "Single Ply";
      } else if(item.ply == 2){
        plyName = "Double Ply";
      } else if(item.ply == 2){
        plyName = "3-Ply";
      } else{
        plyName = "4-Ply";
      }
      

      let orderStatus = statusMap[item.state] || item.state;

      let priceUnit = currency_List.filter(currUnit => currUnit.code === item.units.net_price);
      let dealerPriceUnit = currency_List.filter(currUnit => currUnit.code === item.units.dealer_price);
      let customerPriceUnit = currency_List.filter(currUnit => currUnit.code === item.units.customer_price);
      if(location.state?.status === item.state && location.state?.status !== ""){
      exportDataJSON = {};
      exportDataJSON["poNo"] = item.po? toHandlePOName(item.po) : "";
      exportDataJSON["poDate"] = item.po_date? moment(item.po_date).format("DD-MM-YYYY") : ""; 
      exportDataJSON["orderNo"] = item.number? item.number : "";
      exportDataJSON["produced"] = item.completed? item.completed : 0;
      exportDataJSON["status"] = item.state? orderStatus : "";
      exportDataJSON["customerName"] = item.customer_name? item.customer_name : "";
      exportDataJSON["createdDate"] = item.created_at? moment(item.created_at).format("DD-MM-YYYY") : "";
      exportDataJSON["productSpec"] = item.product_spec? item.product_spec : "";
      exportDataJSON["productCode"] = item.product? item.product : "";
      exportDataJSON["productName"] = item.product_info? item.product_info.name : "";
      exportDataJSON["grade"] = item.product_info? item.product_info.grade  : "";
      exportDataJSON["quality"] = item.product_info? item.product_info.quality : "";
      exportDataJSON["GSM"] = item.product_info? item.product_info.gsm : "";
      exportDataJSON["BF"] = item.product_info? item.product_info.burst_factor : "";
      exportDataJSON["moisture"] = item.product_info? item.product_info.moisture : "";
      exportDataJSON["type"] = item.type? capitalize(item.type) : "";
      exportDataJSON["ply"] = item.ply ? plyName : "";
      exportDataJSON["grain"] = item.grain? item.grain : "";
      exportDataJSON["length"] = `${item.length? item.length : 0}` + ` ${item.units.length ? `${lengthUnit[item.units.length]?.displayName?.toUpperCase()}` : ""}`;
      exportDataJSON["width"] = `${item.width? item.width : 0}` + ` ${item.units.width ? `${lengthUnit[item.units.width]?.displayName?.toUpperCase()}` : ""}`;
      // exportDataJSON["coreOD"] = `${item.core_id? item.core_id : 0}` + ` ${item.units.core_id ? `${lengthUnit[item.units.core_id]?.displayName?.toUpperCase()}`  : ""}`;
      // exportDataJSON["reelOD"] = `${item.reel_od? item.reel_od : 0}` + ` ${item.units.reel_od ? `${lengthUnit[item.units.reel_od]?.displayName?.toUpperCase()}` : ""}`;
      exportDataJSON["coreOD"] = item.inner_dia;
      exportDataJSON["reelOD"] = item.outer_dia;
      exportDataJSON["processedWeight"] = `${item.processed_weight? item.processed_weight.toFixed(3) : ""}` + ` ${item.units.planned_weight ? `${weightUnit[item.units.planned_weight]?.displayName?.toUpperCase()}` : ""}`;
      exportDataJSON["processedQuantity"] = item.processed_quantity? item.processed_quantity.toFixed(3) : "";
      exportDataJSON["deliveryDate"] = item.delivery_date? moment(item.delivery_date).format("DD-MM-YYYY") : "";
      exportDataJSON["deliveryAddress1"] = item.delivery_address_line_1? item.delivery_address_line_1 : "";
      exportDataJSON["deliveryAddress2"] = item.delivery_address_line_2? item.delivery_address_line_2 : "";
      exportDataJSON["deliveryCity"] = item.delivery_city? item.delivery_city : "";
      exportDataJSON["deliveryCountry"] = item.delivery_country? item.delivery_country : "";
      exportDataJSON["deliveryPincode"] = item.delivery_pincode? item.delivery_pincode : "";
      exportDataJSON["deliveryState"] = item.delivery_state? item.delivery_state : "";
      exportDataJSON["deliveryAddress"] = ((item.delivery_address_line_1? item.delivery_address_line_1 : "") + (item.delivery_address_line_2? (", " + item.delivery_address_line_2) : "") + 
      (item.delivery_city? (", " + item.delivery_city) : "") + "" + (item.delivery_state? (", " + item.delivery_state) : "") + (item.delivery_country? (", " + item.delivery_country) : "") + "" + 
      (item.delivery_country? (", " + item.delivery_country) : "") + "" + (item.delivery_pincode? (", " + item.delivery_pincode) : ""));
      exportDataJSON["quotedPrice"] = `${priceUnit ?  priceUnit[0]?.symbol : ""}` + ` ${item.quoted_price? parseFloat(item.quoted_price).toFixed(3) + " " + `${item?.units?.per_weight_unit ? (" /" + weightUnit[item.units.per_weight_unit]?.displayName?.toUpperCase()) : ""}`: ""}`;
      exportDataJSON["netPrice"] = `${(priceUnit && item.net_price) ?   priceUnit[0]?.symbol : ""}` + ` ${item.net_price ? parseFloat(item.net_price).toFixed(3) : ""}`;
      exportDataJSON["dealerPrice"] = `${(dealerPriceUnit && item.dealer_price) ?   dealerPriceUnit[0]?.symbol : ""}` + ` ${item.dealer_price ? parseFloat(item.dealer_price).toFixed(3) : ""}` + 
      `${item?.units?.per_weight_unit ? (" /" + capitalize(weightUnit[item.units.per_weight_unit]?.displayName)) : ""}`;
      exportDataJSON["customerPrice"] = `${(customerPriceUnit && item.customer_price) ?   customerPriceUnit[0]?.symbol : ""}` + ` ${item.customer_price ? parseFloat(item.customer_price).toFixed(3) : ""}` + 
      `${item?.units?.per_weight_unit ? (" /" + capitalize(weightUnit[item.units.per_weight_unit]?.displayName)) : ""}`;
      exportDataJSON["approvedBy"] = item.approved_by? item.approved_by : "";
      exportDataJSON["createdBy"] = item.created_by? item.created_by : "";
      exportDataJSON["rewinderReels"] = item.quantity? item.quantity : 0;
      exportDataJSON["groupNo"] = item.split_group? item.split_group : "";
      exportDataJSON["consignee"] = item.consignee_name? item.consignee_name : "";
      exportDataJSON["shippingAddress"] = ((item.po_details?.shipping_address_line_1? item.po_details?.shipping_address_line_1 : "") +
      (item.po_details?.shipping_address_line_2? (", " + item.po_details?.shipping_address_line_2) : "") + (item.po_details?.shipping_city? (", " + item.po_details?.shipping_city) : "") +
      (item.po_details?.shipping_state? (", " + item.po_details?.shipping_state) : "") + (item.po_details?.shipping_country? (", " + item.po_details?.shipping_country) : "") + 
      (item.po_details?.shipping_pincode? (", " + item.po_details?.shipping_pincode) : ""));
        exportDataJSON["shippingAddress1"] = item.po_details?.shipping_address_line_1? item.po_details?.shipping_address_line_1 : "";
        exportDataJSON["shippingAddress2"] = item.po_details?.shipping_address_line_2? item.po_details?.shipping_address_line_2 : "";
        exportDataJSON["shippingCity"] = item.po_details?.shipping_city? item.po_details?.shipping_city : "";
        exportDataJSON["shippingCountry"] = item.po_details?.shipping_country? item.po_details?.shipping_country : "";
        exportDataJSON["shippingPincode"] = item.po_details?.shipping_pincode? item.po_details?.shipping_pincode : "";
        exportDataJSON["shippingState"] = item.po_details?.shipping_state? item.po_details?.shipping_state : "";
        exportDataJSON["billingAddress1"] = item.po_details?.billing_address_line_1? item.po_details?.billing_address_line_1 : "";
        exportDataJSON["billingAddress2"] = item.po_details?.billing_address_line_2? item.po_details?.billing_address_line_2 : "";
        exportDataJSON["billingCity"] = item.po_details?.billing_city? item.po_details?.billing_city : "";
        exportDataJSON["billingCountry"] = item.po_details?.billing_country? item.po_details?.billing_country : "";
        exportDataJSON["billingPincode"] = item.po_details?.billing_pincode? item.po_details?.billing_pincode : "";
        exportDataJSON["billingState"] = item.po_details?.billing_state? item.po_details?.billing_state : "";
        exportDataJSON["billingAddress"] = ((item.po_details?.billing_address_line_1? item.po_details?.billing_address_line_1 : "") + (item.po_details?.billing_address_line_2? (", " + item.po_details?.billing_address_line_2) : "")
        + (item.po_details?.billing_city? (", " + item.po_details?.billing_city) : "") + (item.po_details?.billing_state? (", " + item.po_details?.billing_state) : "") + (item.po_details?.billing_country? (", " + item.po_details?.billing_country) : "")
        + (item.po_details?.billing_pincode? (", " + item.po_details?.billing_pincode) : ""));
        exportDataJSON["units"] = item.units? item.units : "";
      // if (item.hasOwnProperty('comments')){
      //   exportDataJSON["remarks"] = item.comments? item.comments[item.comments.length-1] : "";
      //  } else{
      //   exportDataJSON["remarks"] = "";
      //  }
      exportDataJSON["remarks"] = item.remarks;
  
       if(item.hasOwnProperty("forced")){
        exportDataJSON["priority"] = item.forced;        
        exportDataJSON["priorityValue"] = item.forced? "Yes" : "No";
       } else{
        exportDataJSON["priority"] = false;
       }

       exportDataJSON["plannedReels"] = item.quantity? item.quantity : 0;

      if (item.hasOwnProperty('planned_weight') && item.planned_weight!= 0) {
        exportDataJSON["plannedWeight"] = item.planned_weight.toFixed(3) + ` ${item.units.planned_weight ? `${weightUnit[item.units.planned_weight]?.displayName?.toUpperCase()}` : ""}`;
      } else {
        exportDataJSON["plannedWeight"] = 0 + ` ${item.units.planned_weight ? `${weightUnit[item.units.planned_weight]?.displayName?.toUpperCase()}` : ""}`;
      }

      if (item.quantity_type) {
        if (item.quantity_type == "weight") {
          exportDataJSON["orderFormat"] = "Weight";
          exportDataJSON["orderWeight"] = `${item.weight? item.weight : 0} ${item.units.weight ? `${weightUnit[item.units.weight]?.displayName?.toUpperCase()}` : ""}` ;
        } else{
          exportDataJSON["orderQuantity"] = item.no_of_reel_sheet ? item.no_of_reel_sheet : 0 ;
          if(item.type == "reel"){
            exportDataJSON["orderFormat"] = "Reels";
          } else{
            exportDataJSON["orderFormat"] = "Sheets";
          }
        }
     } else{
      exportDataJSON["orderWeight"] = 0 + `${item.units.weight ? `${weightUnit[item.units.weight]?.displayName?.toUpperCase()}` : ""}`;
      exportDataJSON["orderQuantity"] = 0;
     }
     exportDataJSON["packagingType"] = item.packaging_details? capitalize(item.packaging_details?.type) : "";
     exportDataJSON["plannedQty"] = item.quantity_type == "weight" ? (item.planning_weight+ " " + capitalize(weightUnit[item.units.weight]?.displayName)) : (item.planning_quantity + " " + capitalize(item.type)+"s"); 
     exportDataJSON["orderQuantity"] = item.quantity_type == "weight" ? (item.weight + " " + capitalize(weightUnit[item.units.weight]?.displayName)) : (item.no_of_reel_sheet + " " + capitalize(item.type)+"s");
     exportDataJSON["pendingQuantity"] = item.total_pending_quantity ? ((item.type.toLowerCase() == "reel" && item.quantity_type == "reel_sheet" ) ? (item.total_pending_quantity?.quantity + " Reels") : (item.total_pending_quantity?.weight + " " + (item.total_pending_quantity.units ? capitalize(weightUnit[item.total_pending_quantity.units.weight]?.displayName) : "")) ): "";
     exportDataJSON["processedQuantity"] = item.total_processed_quantity ? ((item.type.toLowerCase() == "reel" && item.quantity_type == "reel_sheet" ) ? (item.total_processed_quantity.quantity + " Reels") : (item.total_processed_quantity?.weight + " " + (item.total_processed_quantity.units ? capitalize(weightUnit[item.total_processed_quantity.units.weight]?.displayName) : ""))): "";
     exportDataJSON["cancelledQuantity"] = item.cancelled_quantity ? ((item.type.toLowerCase() == "reel" && item.quantity_type == "reel_sheet" ) ? (item.cancelled_quantity.quantity + " Reels") : (item.cancelled_quantity?.weight + " " + (item.cancelled_quantity.units ? capitalize(weightUnit[item.cancelled_quantity.units]?.displayName) : ""))): "";
       exporDataArr.push(exportDataJSON);
      } else{
        exportDataJSON = {};
        exportDataJSON["poNo"] = item.po? toHandlePOName(item.po) : "";
        exportDataJSON["poDate"] = item.po_date? moment(item.po_date).format("DD-MM-YYYY") : ""; 
        exportDataJSON["orderNo"] = item.number? item.number : "";
        exportDataJSON["produced"] = item.completed? item.completed : 0;
        exportDataJSON["status"] = item.state? orderStatus : "";
        exportDataJSON["customerName"] = item.customer_name? item.customer_name : "";
        exportDataJSON["createdDate"] = item.created_at? moment(item.created_at).format("DD-MM-YYYY") : "";
        exportDataJSON["productSpec"] = item.product_spec? item.product_spec : "";
        exportDataJSON["productCode"] = item.product? item.product : "";
        exportDataJSON["productName"] = item.product_info? item.product_info.name : "";
        exportDataJSON["grade"] = item.product_info? item.product_info.grade  : "";
        exportDataJSON["quality"] = item.product_info? item.product_info.quality : "";
        exportDataJSON["GSM"] = item.product_info? item.product_info.gsm : "";
        exportDataJSON["BF"] = item.product_info? item.product_info.burst_factor : "";
        exportDataJSON["moisture"] = item.product_info? item.product_info.moisture : "";
        exportDataJSON["type"] = item.type? capitalize(item.type) : "";
        exportDataJSON["ply"] = item.ply ? plyName : "";
        exportDataJSON["grain"] = item.grain? item.grain : "";
        exportDataJSON["length"] = `${item.length? item.length : 0}` + ` ${item.units.length ? `${lengthUnit[item.units.length]?.displayName?.toUpperCase()}` : ""}`;
        exportDataJSON["width"] = `${item.width? item.width : 0}` + ` ${item.units.width ? `${lengthUnit[item.units.width]?.displayName?.toUpperCase()}` : ""}`;
        // exportDataJSON["coreOD"] = `${item.core_id? item.core_id : 0}` + ` ${item.units.core_id ? `${lengthUnit[item.units.core_id]?.displayName?.toUpperCase()}` : ""}`;
        // exportDataJSON["reelOD"] = `${item.reel_od? item.reel_od : 0}` + ` ${item.units.reel_od ? `${lengthUnit[item.units.reel_od]?.displayName?.toUpperCase()}` : ""}`;
        exportDataJSON["coreOD"] = item.inner_dia;
        exportDataJSON["reelOD"] = item.outer_dia;
        exportDataJSON["processedWeight"] = `${item.processed_weight? item.processed_weight.toFixed(3) : 0}` + ` ${item.units.planned_weight ? `${weightUnit[item.units.planned_weight]?.displayName?.toUpperCase()}` : ""}`;
        exportDataJSON["processedQuantity"] = item.processed_quantity? item.processed_quantity : 0;
        exportDataJSON["deliveryDate"] = item.delivery_date? moment(item.delivery_date).format("DD-MM-YYYY") : "";
        exportDataJSON["deliveryAddress1"] = item.delivery_address_line_1? item.delivery_address_line_1 : "";
        exportDataJSON["deliveryAddress2"] = item.delivery_address_line_2? item.delivery_address_line_2 : "";
        exportDataJSON["deliveryCity"] = item.delivery_city? item.delivery_city : "";
        exportDataJSON["deliveryCountry"] = item.delivery_country? item.delivery_country : "";
        exportDataJSON["deliveryPincode"] = item.delivery_pincode? item.delivery_pincode : "";
        exportDataJSON["deliveryState"] = item.delivery_state? item.delivery_state : "";
        exportDataJSON["deliveryAddress"] = ((item.delivery_address_line_1? item.delivery_address_line_1 : "") + (item.delivery_address_line_2? (", " + item.delivery_address_line_2) : "") + 
      (item.delivery_city? (", " + item.delivery_city) : "") + "" + (item.delivery_state? (", " + item.delivery_state) : "") + (item.delivery_country? (", " + item.delivery_country) : "") + "" + 
      (item.delivery_country? (", " + item.delivery_country) : "") + "" + (item.delivery_pincode? (", " + item.delivery_pincode) : ""));
        exportDataJSON["quotedPrice"] = `${priceUnit ?  priceUnit[0]?.symbol : ""}` + ` ${item.quoted_price? parseFloat(item.quoted_price).toFixed(3) + " " + `${item?.units?.per_weight_unit ? (" /" + weightUnit[item.units.per_weight_unit]?.displayName?.toUpperCase()) : ""}`: ""}`;
        exportDataJSON["netPrice"] = `${(priceUnit && item.net_price) ?   priceUnit[0]?.symbol : ""}` + ` ${item.net_price? parseFloat(item.net_price).toFixed(3) : ""}`;
        exportDataJSON["dealerPrice"] = `${(dealerPriceUnit && item.dealer_price) ?   dealerPriceUnit[0]?.symbol : ""}` + ` ${item.dealer_price ? parseFloat(item.dealer_price).toFixed(3) : ""}` + 
      `${item?.units?.per_weight_unit ? (" /" + capitalize(weightUnit[item.units.per_weight_unit]?.displayName)) : ""}`;
      exportDataJSON["customerPrice"] = `${(customerPriceUnit && item.customer_price) ?   customerPriceUnit[0]?.symbol : ""}` + ` ${item.customer_price ? parseFloat(item.customer_price).toFixed(3) : ""}` + 
      `${item?.units?.per_weight_unit ? (" /" + capitalize(weightUnit[item.units.per_weight_unit]?.displayName)) : ""}`;
        exportDataJSON["approvedBy"] = item.approved_by? item.approved_by : "";
        exportDataJSON["createdBy"] = item.created_by? item.created_by : "";
        exportDataJSON["rewinderReels"] = item.quantity? item.quantity : 0;
        exportDataJSON["groupNo"] = item.split_group? item.split_group : "";
        exportDataJSON["consignee"] = item.consignee_name? item.consignee_name : "";
        exportDataJSON["shippingAddress"] = ((item.po_details?.shipping_address_line_1? item.po_details?.shipping_address_line_1 : "") +
      (item.po_details?.shipping_address_line_2? (", " + item.po_details?.shipping_address_line_2) : "") + (item.po_details?.shipping_city? (", " + item.po_details?.shipping_city) : "") +
      (item.po_details?.shipping_state? (", " + item.po_details?.shipping_state) : "") + (item.po_details?.shipping_country? (", " + item.po_details?.shipping_country) : "") + 
      (item.po_details?.shipping_pincode? (", " + item.po_details?.shipping_pincode) : ""));
        exportDataJSON["shippingAddress1"] = item.po_details?.shipping_address_line_1? item.po_details?.shipping_address_line_1 : "";
        exportDataJSON["shippingAddress2"] = item.po_details?.shipping_address_line_2? item.po_details?.shipping_address_line_2 : "";
        exportDataJSON["shippingCity"] = item.po_details?.shipping_city? item.po_details?.shipping_city : "";
        exportDataJSON["shippingCountry"] = item.po_details?.shipping_country? item.po_details?.shipping_country : "";
        exportDataJSON["shippingPincode"] = item.po_details?.shipping_pincode? item.po_details?.shipping_pincode : "";
        exportDataJSON["shippingState"] = item.po_details?.shipping_state? item.po_details?.shipping_state : "";
        exportDataJSON["billingAddress1"] = item.po_details?.billing_address_line_1? item.po_details?.billing_address_line_1 : "";
        exportDataJSON["billingAddress2"] = item.po_details?.billing_address_line_2? item.po_details?.billing_address_line_2 : "";
        exportDataJSON["billingCity"] = item.po_details?.billing_city? item.po_details?.billing_city : "";
        exportDataJSON["billingCountry"] = item.po_details?.billing_country? item.po_details?.billing_country : "";
        exportDataJSON["billingPincode"] = item.po_details?.billing_pincode? item.po_details?.billing_pincode : "";
        exportDataJSON["billingState"] = item.po_details?.billing_state? item.po_details?.billing_state : "";
        exportDataJSON["billingAddress"] = ((item.po_details?.billing_address_line_1? item.po_details?.billing_address_line_1 : "") + (item.po_details?.billing_address_line_2? (", " + item.po_details?.billing_address_line_2) : "")
        + (item.po_details?.billing_city? (", " + item.po_details?.billing_city) : "") + (item.po_details?.billing_state? (", " + item.po_details?.billing_state) : "") + (item.po_details?.billing_country? (", " + item.po_details?.billing_country) : "")
        + (item.po_details?.billing_pincode? (", " + item.po_details?.billing_pincode) : ""));
        exportDataJSON["units"] = item.units? item.units : "";
        // if (item.hasOwnProperty('comments')){
        //   exportDataJSON["remarks"] = item.comments? item.comments[item.comments.length-1] : "";
        //  } else{
        //   exportDataJSON["remarks"] = "";
        //  }
        exportDataJSON["remarks"] = item.remarks;
    
         if(item.hasOwnProperty("forced")){
          exportDataJSON["priority"] = item.forced;        
          exportDataJSON["priorityValue"] = item.forced? "Yes" : "No";
         } else{
          exportDataJSON["priority"] = false;
         }
  
         exportDataJSON["plannedReels"] = item.quantity? item.quantity : 0;
  
         if (item.hasOwnProperty('planned_weight') && item.planned_weight!= 0) {
          exportDataJSON["plannedWeight"] = item.planned_weight.toFixed(3) + ` ${item.units.planned_weight ? `${weightUnit[item.units.planned_weight]?.displayName?.toUpperCase()}` : ""}`;
        } else {
          exportDataJSON["plannedWeight"] = 0 + ` ${item.units.planned_weight ? `${weightUnit[item.units.planned_weight]?.displayName?.toUpperCase()}` : ""}`;
        }
  
        if (item.quantity_type) {
          if (item.quantity_type == "weight") {
            exportDataJSON["orderFormat"] = "Weight";
            exportDataJSON["orderWeight"] = `${item.weight? item.weight : 0} ${item.units.weight ? `${weightUnit[item.units.weight]?.displayName?.toUpperCase()}` : ""}` ;
          } else{
            exportDataJSON["orderQuantity"] = item.no_of_reel_sheet ? item.no_of_reel_sheet : 0 ;
            if(item.type == "reel"){
              exportDataJSON["orderFormat"] = "Reels";
            } else{
              exportDataJSON["orderFormat"] = "Sheets";
            }
          }
       } else{
        exportDataJSON["orderWeight"] = 0 + `${item.units.weight ? `${weightUnit[item.units.weight]?.displayName?.toUpperCase()}` : ""}`;
        exportDataJSON["orderQuantity"] = 0;
       }
        exportDataJSON["packagingType"] = item.packaging_details? capitalize(item.packaging_details?.type) : "";
        exportDataJSON["plannedQty"] = item.quantity_type == "weight" ? (item.planning_weight+ " " + capitalize(weightUnit[item.units.weight]?.displayName)) : (item.planning_quantity + " " + capitalize(item.type)+"s"); 
        exportDataJSON["orderQuantity"] = item.quantity_type == "weight" ? (item.weight + " " + capitalize(weightUnit[item.units.weight]?.displayName)) : (item.no_of_reel_sheet + " " + capitalize(item.type)+"s");
        exportDataJSON["pendingQuantity"] = item.total_pending_quantity ? ((item.type.toLowerCase() == "reel" && item.quantity_type == "reel_sheet" ) ? (item.total_pending_quantity?.quantity + " Reels") : (item.total_pending_quantity?.weight + " " + (item.total_pending_quantity.units ? capitalize(weightUnit[item.total_pending_quantity.units.weight]?.displayName) : "")) ): "";
        exportDataJSON["processedQuantity"] = item.total_processed_quantity ? ((item.type.toLowerCase() == "reel" && item.quantity_type == "reel_sheet" ) ? (item.total_processed_quantity.quantity + " Reels") : (item.total_processed_quantity?.weight + " " + (item.total_processed_quantity.units ? capitalize(weightUnit[item.total_processed_quantity.units.weight]?.displayName) : ""))): "";
        exportDataJSON["cancelledQuantity"] = item.cancelled_quantity ? ((item.type.toLowerCase() == "reel" && item.quantity_type == "reel_sheet" ) ? (item.cancelled_quantity.quantity + " Reels") : (item.cancelled_quantity?.weight + " " + (item.cancelled_quantity.units ? capitalize(weightUnit[item.cancelled_quantity.units]?.displayName) : ""))): "";
        exporDataArr.push(exportDataJSON);
      }
    });
    setOrderRecords(exporDataArr);
    location?.state?.exportOrderDetail && setExportOrderDetail(location?.state?.exportOrderDetail);
  };

  const exportStatusChange = (e) => {
    setExportOrderDetail(e.target.value);
  };

  const exportHandler = async() => {
    if(orderRecords.length){
      if(exportOrderDetail === "CSV"){
       try{
          const workbook = new ExcelJS.Workbook();
          const worksheet = workbook.addWorksheet('Order Records');

          const headers = orderMangtRecords?.length ? headersForOrderMangt : headersForDeckleMangt;

          worksheet.columns = headers.map((header)=>({
            header: header.label,
            key: header.key,
          }))

          const headRow = worksheet.getRow(1);

          headRow.eachCell((cell)=>{
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: {
                argb: "f3f4f6"
              }
            }
            cell.font = {
              bold: true,
            }
          })

          orderRecords?.forEach((record)=>{
            const row = worksheet.addRow(record);
          })

          worksheet.columns.forEach((column)=>{
            let maxLength = 10;
            column.eachCell((cell)=>{
              let value = cell?.value?.toString() || "";
              maxLength = Math.max(maxLength,value?.length);
            })
            column.width = maxLength>50?50:maxLength+2;
          })

          const buffer = await workbook.xlsx.writeBuffer();
          saveAs(new Blob([buffer]),`${fileName}.xlsx`)
        }
        catch(e)
        {
          console.log(e);
        }
      } else {
        //for PDF option
        // if(orderMangtRecords?.length){
        //   navigate(`${location?.state?.rootPage}/export-orders/pdf`, {
        //         state: {
        //           body: location?.state?.body,
        //             orderMangtRecords: orderRecords,
        //             // switchReelCoreOD: switchReelCoreOD,
        //             switchOrderFormat: switchOrderFormat,
        //             // switchPlannedWt: switchPlannedWt,
        //             // switchPlannedReels: switchPlannedReels,
        //             switchPrice: switchPrice,
        //             switchAddress: switchAddress,
        //             shippingAddress: shippingAddress,
        //             billingAddress: billingAddress,
        //             switchApprover: switchApprover,
        //             switchCreatedBy: switchCreatedBy,
        //             switchDeliveryDate: switchDeliveryDate,
        //             switchCreatedDate: switchCreatedDate,
        //             switchStatus: switchStatus,
        //             switchPriority: switchPriority,
        //             switchProductName: switchProductName,
        //             switchQtyPlanned: switchQtyPlanned,
        //             switchPackaging: switchPackaging,
        //             switchDiameter: switchDiameter,
        //             rootPage: location?.state?.rootPage,
        //             fileName: fileName,
        //             count: location?.state?.count,
        //             exportOrderDetail: exportOrderDetail
        //           },
        //   });
        // } else {
        //   navigate(`${location?.state?.rootPage}/export-orders/pdf`, {
        //     state: {
        //         body: location?.state?.body,
        //         deckleOrders: orderRecords,
        //         // switchReelCoreOD: switchReelCoreOD,
        //         switchOrderFormat: switchOrderFormat,
        //         // switchPlannedWt: switchPlannedWt,
        //         // switchPlannedReels: switchPlannedReels,
        //         switchPrice: switchPrice,
        //         switchAddress: switchAddress,
        //         shippingAddress: shippingAddress,
        //         billingAddress: billingAddress,
        //         switchApprover: switchApprover,
        //         switchCreatedBy: switchCreatedBy,
        //         switchDeliveryDate: switchDeliveryDate,
        //         switchCreatedDate: switchCreatedDate,
        //         switchStatus: switchStatus,
        //         switchPriority: switchPriority,
        //         switchProductName: switchProductName,
        //         switchQtyPlanned: switchQtyPlanned,
        //         switchPackaging: switchPackaging,
        //         switchDiameter: switchDiameter,
        //         rootPage: location?.state?.rootPage,
        //         fileName: fileName,
        //         count: location?.state?.count,
        //         exportOrderDetail: exportOrderDetail
        //       },
        //   });
        // }
      }
    } else{
      navigate(`${location?.state?.rootPage}/preparing-export-orders`, {
        state: {
          body: location?.state?.body,
          rootPage: location?.state?.rootPage,
          // switchReelCoreOD: switchReelCoreOD,
          switchOrderFormat: switchOrderFormat,
          // switchPlannedWt: switchPlannedWt,
          // switchPlannedReels: switchPlannedReels,
          switchPrice: switchPrice,
          switchAddress: switchAddress,
          shippingAddress: shippingAddress,
          billingAddress: billingAddress,
          switchApprover: switchApprover,
          switchCreatedBy: switchCreatedBy,
          switchDeliveryDate: switchDeliveryDate,
          switchCreatedDate: switchCreatedDate,
          switchStatus: switchStatus,
          switchPriority: switchPriority,
          switchProductName: switchProductName,
          switchQtyPlanned: switchQtyPlanned,
          switchPackaging: switchPackaging,
          switchDiameter: switchDiameter,
          fileName: fileName,
          count: location?.state?.count,
          headers: headersForOrderMangt,
          exportOrderDetail: exportOrderDetail
        },
      });
    }
  }
  const orderFormatHandler = (checked) => {
    setSwitchOrderFormat(checked);
  }
  const priceHandler = (checked) => {
    setSwitchPrice(checked);
  }
  const addressHandler = (checked) => {
    setSwitchAddress(checked);
  }
  const shippingAddHandler = (checked) => {
    setShippingAddress(checked);
  }
  const billingAddHandler = (checked) => {
    setBillingAddress(checked);
  }
  const approverHandler = (checked) => {
    setSwitchApprover(checked);
  }
  const createdByHandler = (checked) => {
    setSwitchCreatedBy(checked);
  }
  const deliveryDateHandler = (checked) => {
    setSwitchDelDate(checked);
  }
  const createdDateHandler = (checked) => {
    setSwitchCreatedDate(checked);
  }
  const statusHandler = (checked) => {
    setSwitchStatus(checked);
  }
  const priorityHandler = (checked) => {
    setSwitchPriority(checked);
  }
  const productHandler = (checked) => {
    setSwitchProductName(checked);
  }
  // const displatchedQtyHandlder = (checked) => {
  //   setSwitchDispatchedQty(checked);
  // }
  const diameterHandler = (checked) => {
    setSwitchDiameter(checked);
  }
  const qtyToBePlannedHandler = (checked) => {
    setSwitchQtyPlanned(checked);
  }
  const packagingHandler = (checked) => {
    setSwitchPackaging(checked);
  }
  // return orderRecords ? (
    return (
    <RightLayoutContainer>
      <PageTitleComp className="marginRightAdg">
          <PageHeader
          ghost={false}
          onBack={() => navigate(location.state?.rootPage)}
            // title="Export Order Records"
            title={"Export " + location?.state?.body?.page}
          extra={[
            <Button
              key="1"
              className="themeBtn noBg"
              onClick={() => navigate(location?.state?.rootPage)}
            >
              <Iconmoon icon="wrong" size={14} color="#EA655B" />
              Cancel
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <DetailFields>
        <HaberForm>
          <div className="groupDetailWrap">
            <Form name="basic" autoComplete="off" className="haberLogin">
            <Row gutter={[16, 16]} className="groupForm lastGroup">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Export Format</h2>
                    <p>
                      Here you can select the format to download data
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                          <div className="boxFieldTitle">
                          <label>Data Format</label>
                            <p>
                              Records can be exported in CSV format.
                            </p>
                          </div>
                    </Col>
                    <Col span={12}>
                      <div
                        className="boxFormType switchRadio csvStyle"
                        // 
                        style={{ justifyContent: "flex-end", displayName: "flex", textAlign: "right" }}
                      >
                        <Radio.Group
                          options={exportCustomerData}
                          onChange={exportStatusChange}
                          value={exportOrderDetail? exportOrderDetail : "CSV"}
                          disabled={true}
                          optionType="button"
                          buttonStyle="solid"
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
            </Row>

            <Row gutter={[16, 16]} className="groupForm">
              <Col span={8}>
                    <GroupTitle>
                      <h2>Select Options</h2>
                      <p>
                        Here you can select data that should be downloaded along with the basic details of orders
                      </p>
                    </GroupTitle>
              </Col>
              <Col span={16}>
                <Row className="centerAlign">
                  <Col span={12}>
                      <div className="boxFieldTitle">
                            <label>Product Name</label>
                      </div>
                  </Col>
                  <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Styled>
                          <Tooltip
                              placement="bottomRight"
                              title={
                                switchProductName ? "Exclude Product Name in the records" : "Include Product Name in the records"
                              }
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                            <Switch
                                  checked={switchProductName}
                                onChange={productHandler}
                                className="switch-new"
                            />
                          </Tooltip>
                          </Styled>
                        </GlobalSet>
                      </div>
                  </Col>
                </Row>
                {(location?.state?.body?.page === "order records" || location?.state?.body?.page === "approve order records") && <Row className="centerAlign">
                  <Col span={12}>
                      <div className="boxFieldTitle">
                            <label>Price Details</label>
                      </div>
                  </Col>
                  <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Styled>
                          <Tooltip
                              placement="bottomRight"
                              title={
                                switchPrice ? "Exclude Price Details in the records" : "Include Price Details in the records"
                              }
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                              <Switch
                                  checked={switchPrice}
                                  onChange={priceHandler}
                                  className="switch-new"
                              />
                          </Tooltip>
                          </Styled>
                        </GlobalSet>
                      </div>
                  </Col>
                </Row>}
                {/* {location?.state?.body?.page === "deckle order records" && <Row className="centerAlign">
                  <Col span={12}>
                        <div className="boxFieldTitle">
                              <label>Disapatched Quantity</label>
                        </div>
                  </Col>
                  <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Styled>
                          <Switch
                                checked={switchDispatchedQty}
                                onChange={displatchedQtyHandlder}
                                className="switch-new"
                              />
                          </Styled>
                        </GlobalSet>
                      </div>
                  </Col>
                </Row>} */}
                <Row className="centerAlign">
                  <Col span={12}>
                      <div className="boxFieldTitle">
                            <label>Order Format</label>
                      </div>
                  </Col>
                  <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Styled>
                          <Tooltip
                              placement="bottomRight"
                              title={
                                switchOrderFormat ? "Exclude Order Format in the records" : "Include Order Format in the records"
                              }
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                            <Switch
                                  checked={switchOrderFormat}
                                  onChange={orderFormatHandler}
                                  className="switch-new"
                                />
                          </Tooltip>
                          </Styled>
                        </GlobalSet>
                      </div>
                  </Col>
                </Row>
                {(location?.state?.body?.page === "order records" || location?.state?.body?.page === "approve order records") && <Row className="centerAlign">
                  <Col span={12}>
                      <div className="boxFieldTitle">
                            <label>Order Status</label>
                      </div>
                  </Col>
                  <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Styled>
                              <Tooltip
                              placement="bottomRight"
                              title={
                                switchStatus ? "Exclude Order Status in the records" : "Include Order Status in the records"
                              }
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                            <Switch
                                  checked={switchStatus}
                                  onChange={statusHandler}
                                  className="switch-new"
                                />
                          </Tooltip>
                          </Styled>
                        </GlobalSet>
                      </div>
                  </Col>
                </Row>}
                <Row className="centerAlign">
                  <Col span={12}>
                      <div className="boxFieldTitle">
                            <label>Order Priority</label>
                      </div>
                  </Col>
                  <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Styled>
                          <Tooltip
                              placement="bottomRight"
                              title={
                                switchPriority ? "Exclude Order Priority in the records" : "Include Order Priority in the records"
                              }
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                              <Switch
                                  checked={switchPriority}
                                  onChange={priorityHandler}
                                  className="switch-new"
                              />
                            </Tooltip>
                          </Styled>
                        </GlobalSet>
                      </div>
                  </Col>
                </Row>
                {(location?.state?.body?.page === "deckle order records" && location?.state?.body?.tabName === "pending_for_deckle_match") && <Row className="centerAlign">
                  <Col span={12}>
                      <div className="boxFieldTitle">
                            <label>Diameter Details</label>
                      </div>
                  </Col>
                  <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Styled>
                          <Tooltip
                              placement="bottomRight"
                              title={
                                switchDiameter ? "Exclude Diameter Details in the records" : "Include Diameter Details in the records"
                              }
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                          <Switch
                                checked={switchDiameter}
                                onChange={diameterHandler}
                                className="switch-new"
                              />
                              </Tooltip>
                          </Styled>
                        </GlobalSet>
                      </div>
                  </Col>
                </Row>}
                {(location?.state?.body?.page === "deckle order records" && location?.state?.body?.tabName === "pending_for_deckle_match") && <Row className="centerAlign">
                  <Col span={12}>
                      <div className="boxFieldTitle">
                          <label>Quantity to be Planned</label>
                      </div>
                  </Col>
                  <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Styled>
                          <Tooltip
                              placement="bottomRight"
                              title={
                                switchQtyPlanned ? "Exclude Quantity to be Planned in the records" : "Include Quantity to be Planned in the records"
                              }
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                          <Switch
                                checked={switchQtyPlanned}
                                onChange={qtyToBePlannedHandler}
                                className="switch-new"
                              />
                          </Tooltip>
                          </Styled>
                        </GlobalSet>
                      </div>
                  </Col>
                </Row>}
                <Row className="centerAlign">
                  <Col span={12}>
                      <div className="boxFieldTitle">
                            <label>Packaging Details</label>
                      </div>
                  </Col>
                  <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Styled>
                          <Tooltip
                              placement="bottomRight"
                              title={
                                switchPackaging ? "Exclude Packaging Details in the records" : "Include Packaging Details in the records"
                              }
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                          <Switch
                                checked={switchPackaging}
                                onChange={packagingHandler}
                                className="switch-new"
                              />
                              </Tooltip>
                          </Styled>
                        </GlobalSet>
                      </div>
                  </Col>
                </Row>
                <Row className="centerAlign">
                  <Col span={12}>
                      <div className="boxFieldTitle">
                            <label>Delivery Date</label>
                      </div>
                  </Col>
                  <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Styled>
                          <Tooltip
                              placement="bottomRight"
                              title={
                                switchDeliveryDate ? "Exclude Delivery Date in the records" : "Include Delivery Date in the records"
                              }
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                          <Switch
                                checked={switchDeliveryDate}
                                onChange={deliveryDateHandler}
                                className="switch-new"
                              />
                              </Tooltip>
                          </Styled>
                        </GlobalSet>
                      </div>
                  </Col>
                </Row>
                {(location?.state?.body?.page === "order records" || location?.state?.body?.page === "approve order records") && <Row className="centerAlign">
                  <Col span={12}>
                      <div className="boxFieldTitle">
                            <label>Created Date</label>
                      </div>
                  </Col>
                  <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Styled>
                          <Tooltip
                              placement="bottomRight"
                              title={
                                switchCreatedDate ? "Exclude Created Date in the records" : "Include Created Date in the records"
                              }
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                          <Switch
                                checked={switchCreatedDate}
                                onChange={createdDateHandler}
                                className="switch-new"
                              />
                              </Tooltip>
                          </Styled>
                        </GlobalSet>
                      </div>
                  </Col>
                </Row>}
                <Row className="centerAlign">
                  <Col span={12}>
                      <div className="boxFieldTitle">
                            <label>Delivery Address</label>
                      </div>
                  </Col>
                  <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Styled>
                              <Tooltip
                              placement="bottomRight"
                              title={
                                switchAddress ? "Exclude Delivery Address in the records" : "Include Delivery Address in the records"
                              }
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                            <Switch
                                  checked={switchAddress}
                                  onChange={addressHandler}
                                  className="switch-new"
                                />
                              </Tooltip>
                          </Styled>
                        </GlobalSet>
                      </div>
                  </Col>
                </Row>
                <Row className="centerAlign">
                  <Col span={12}>
                      <div className="boxFieldTitle">
                            <label>Billing Address</label>
                      </div>
                  </Col>
                  <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Styled>
                              <Tooltip
                              placement="bottomRight"
                              title={
                                billingAddress ? "Exclude Billing Address in the records" : "Include Billing Address in the records"
                              }
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                            <Switch
                                  checked={billingAddress}
                                  onChange={billingAddHandler}
                                  className="switch-new"
                                />
                              </Tooltip>
                          </Styled>
                        </GlobalSet>
                      </div>
                  </Col>
                </Row>
                <Row className="centerAlign">
                  <Col span={12}>
                      <div className="boxFieldTitle">
                            <label>Shipping Address</label>
                      </div>
                  </Col>
                  <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Styled>
                          <Tooltip
                              placement="bottomRight"
                              title={
                                shippingAddress ? "Exclude Shipping Address in the records" : "Include Shipping Address in the records"
                              }
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                          <Switch
                                checked={shippingAddress}
                                onChange={shippingAddHandler}
                                className="switch-new"
                              />
                              </Tooltip>
                          </Styled>
                        </GlobalSet>
                      </div>
                  </Col>
                </Row>
                <Row className="centerAlign">
                  <Col span={12}>
                      <div className="boxFieldTitle">
                            <label>Approved By</label>
                      </div>
                  </Col>
                  <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Styled>
                          <Tooltip
                              placement="bottomRight"
                              title={
                                switchApprover ? "Exclude Approved By in the records" : "Include Approved By in the records"
                              }
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                          <Switch
                                checked={switchApprover}
                                onChange={approverHandler}
                                className="switch-new"
                              />
                              </Tooltip>
                          </Styled>
                        </GlobalSet>
                      </div>
                  </Col>
                </Row>
                <Row className="centerAlign">
                  <Col span={12}>
                      <div className="boxFieldTitle">
                            <label>Created By</label>
                      </div>
                  </Col>
                  <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Styled>
                          <Tooltip
                              placement="bottomRight"
                              title={
                                switchCreatedBy ? "Exclude Created By in the records" : "Include Created By in the records"
                              }
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                          <Switch
                                checked={switchCreatedBy}
                                onChange={createdByHandler}
                                className="switch-new"
                              />
                              </Tooltip>
                          </Styled>
                        </GlobalSet>
                      </div>
                  </Col>
                </Row>
              </Col>
            </Row>

            <div className="buttonRight" style={{ marginTop: "20px" }}>
                {/* {!exportOrderDetail || exportOrderDetail === "PDF" ? ( */}
                {exportOrderDetail === "PDF" ? (  <Form.Item>
                      <Button
                      onClick={() => exportHandler()}
                      className="themeBtn"
                    >
                      Preview &#38; Download Records
                    </Button>
                    </Form.Item>
                ) : (
                  <Form.Item>
                    <Button className="themeBtn csv"
                          onClick={() => exportHandler()}>
                            Download Order Records
                    </Button>
                  </Form.Item>
                )}
              </div>
            </Form>
          </div>
        </HaberForm>
      </DetailFields>
    </RightLayoutContainer>
  );
};

export default ExportOrders;
